module.exports = __webpack_public_path__ + "static/media/sab.a1420408.png";